<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showOrder") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="form_title_wrapper">
            <h4>{{ $t("SIDENAV.OrderData.clientData") }}</h4>
          </div>
          <base-input
            v-if="data.user?.name"
            col="6"
            type="text"
            :placeholder="$t('TABLES.Orders.clientName')"
            v-model.trim="data.user.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.CLIENT_PHONE')"
            v-model.trim="data.user.mobile"
            disabled
          />
          <div class="form_title_wrapper">
            <h4>{{ $t("PLACEHOLDERS.PROVIDER_INFO") }}</h4>
          </div>

          <base-input
            col="4"
            v-if="data.store?.store_name"
            type="text"
            :placeholder="$t('PLACEHOLDERS.store_name')"
            v-model.trim="data.store.store_name"
            disabled
          />

          <base-input
            v-if="data.store?.store_mobile"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_phone')"
            v-model.trim="data.store.store_mobile"
            disabled
          />
          <base-input
            v-if="data.store?.category?.name"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.category')"
            v-model.trim="data.store.category.name"
            disabled
          />

          <div class="form_title_wrapper">
            <h4>{{ $t("PLACEHOLDERS.order_data") }}</h4>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_method')"
            v-model.trim="data.payment_method"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.order_date')"
            v-model.trim="data.order_date"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.order_status')"
            v-model.trim="data.status_trans"
            disabled
          />

          <template
            v-if="
              data.status != 'waiting_address' &&
              data.status_delivery == 'Delivery'
            "
          >
            <div class="form_title_wrapper">
              <h4>{{ $t("PLACEHOLDERS.recive_method") }}</h4>
            </div>
            <MapComponent
              :lat="data.orderLocation.latitude"
              :lng="data.orderLocation.longitude"
            />
            <div class="row">
              <div class="row">
                <base-input
                  col="6"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.city')"
                  v-model.trim="data.orderLocation.city"
                  disabled
                />
                <base-input
                  col="6"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.district')"
                  v-model.trim="data.orderLocation.district"
                  disabled
                />
                <base-input
                  col="6"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.street')"
                  v-model.trim="data.orderLocation.street_name"
                  disabled
                />

                <base-input
                  col="6"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.build')"
                  v-model.trim="data.orderLocation.build_name"
                  disabled
                />
              </div>
            </div>
          </template>

          <div class="col-12" v-if="data.orderItems?.length">
            <div class="form_title_wrapper">
              <h4>{{ $t("PLACEHOLDERS.requested_products_offers") }}</h4>
            </div>

            <div
              class="col-lg-12 row"
              v-for="product in data.orderItems"
              :key="product"
            >
              <base-image-upload-input
                col="12"
                :disabled="true"
                identifier="admin_image"
                v-if="product.itemable_type == 'Offer'"
                :placeholder="$t('PLACEHOLDERS.product_image')"
                :preSelectedImage="product.image"
                @selectImage="selectImage"
              />
              <base-image-upload-input
                col="12"
                :disabled="true"
                identifier="admin_image"
                v-else
                :placeholder="$t('PLACEHOLDERS.product_image')"
                :preSelectedImage="product.image"
                @selectImage="selectImage"
              />
              <base-input
                v-if="product?.product_name"
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.product_name')"
                v-model.trim="product.product_name"
                disabled
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.product_price')"
                v-model.trim="product.price"
                disabled
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.product_quantity')"
                v-model.trim="product.quantity"
                disabled
              />
              <base-input
                v-if="product?.size"
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.product_size')"
                v-model.trim="product.size.name"
                disabled
              />
            </div>
          </div>

          <div class="form_title_wrapper">
            <h4>{{ $t("PLACEHOLDERS.payment_data") }}</h4>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.total_price_without_tax')"
            v-model.trim="data.price_product"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.delivery_price')"
            v-model.trim="data.price_delivery"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tax')"
            v-model.trim="data.tax"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.total_with_tax')"
            v-model.trim="data.total"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.admin_profit_from_delivery_agent')"
            v-model.trim="data.profit_from_delivety"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.net_profit_from_delivery_agent')"
            v-model="data.delivery_net_profit"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.admin_profit_from_service_provider')"
            v-model="data.profit_from_provider"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.net_profit_from_service_provider')"
            v-model="data.service_provider_profit"
            disabled
          />
          <template v-if="data.status == 'waiting_address'">
            <ChangableMapComponent
              :lat="parseFloat(form.latitude)"
              :lng="parseFloat(form.longitude)"
              @update:lat="form.latitude = $event"
              @update:lng="form.longitude = $event"
            />
            <div class="row">
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.city')"
                v-model.trim="form.city"
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.district')"
                v-model.trim="form.district"
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.street')"
                v-model.trim="form.street_name"
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.building')"
                v-model.trim="form.build_name"
              />

              <!-- <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.address')"
                v-model.trim="form.address"
              /> -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.price_delivary')"
                v-model.trim="form.price_delivery"
              />
            </div>
            <div class="btn_wrapper">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="isWaitingRequest"
              />
            </div>
          </template>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
// import RatingPreview from "@/components/ui/RatingPreview.vue";
import RatingPreview from "../../../components/ui/RatingPreview.vue";
import MapComponent from "../../../components/general/MapComponent.vue";
import ChangableMapComponent from "../../../components/general/ChangableMapComponent.vue";

export default {
  components: { RatingPreview, MapComponent, ChangableMapComponent },
  name: "showCity",
  comments: {
    RatingPreview,
  },
  data() {
    return {
      isWaitingRequest: false,

      data: {
        user: {
          name: null,
          mobile: null,
        },
        store: null,
        order_number: null,
        order: null,
        order_date: null,
        lat: "",
        long: "",
        orderItems: null,
        price_product: null,
        price_delivery: null,
        tax: null,
        status_trans: null,
        total: null,
        profit_from_delivety: null,
        profit_from_provider: null,
        service_provider_profit: null,
        delivery_net_profit: null,
        payment_method: null,
        totalePrce: null,
        totalTax: null,
        totalOrderPrice: null,
        orderLocation: null,
        status_delivery: null,
      },
      form: {
        district: "",
        city: "",
        address: "",
        street_name: "",
        build_name: "",
        address: "",
        price_delivery: "",
        latitude: "18.0735",
        longitude: "-15.9582",
      },
      regions: [],
      // End:: Data Collection To Send
    };
  },

  computed: {},

  methods: {
    addRow() {
      this.phones.push({ phone: "" });
    },

    removeRow(index) {
      this.phones.splice(index, 1);
    },
    // start show data
    async showOrder() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `orders/${this.$route.params.id}`,
        });
        this.data.user = res.data.data.Order?.user;
        this.data.store = res.data.data.Order?.store;
        this.data.order = res.data.data.Order?.order;
        this.data.order_number = res.data.data.Order?.order_number;
        this.data.status = res.data.data.Order?.status;
        this.data.status_trans = res.data.data.Order?.status_trans;
        this.data.status_delivery = res.data.data.Order?.status_delivery;
        this.data.order_date = res.data.data.Order?.created_at;
        this.data.orderItems = res.data.data.Order?.orderItems;
        this.data.payment_method = res.data.data.Order?.payment_method;
        this.data.price_product =
          res.data.data.Order?.orderBudget?.price_product;
        this.data.price_delivery =
          res.data.data.Order?.orderBudget?.price_delivery;
        this.data.tax = res.data.data.Order?.orderBudget?.tax;
        this.data.total = res.data.data.Order?.orderBudget?.total;
        this.data.profit_from_delivety =
          res.data.data.Order?.orderBudget?.profit_from_delivety;
        this.data.delivery_net_profit =
          res.data.data.Order?.orderBudget?.delivery_net_profit;
        this.data.profit_from_provider =
          res.data.data.Order?.orderBudget?.profit_from_provider;
        this.data.service_provider_profit =
          res.data.data.Order?.orderBudget?.service_provider_profit;
        this.data.orderLocation = res.data.data.Order?.orderLocation;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
          params: {
            is_active: 1,
          },
        });
        // console.log("Cities =>", res.data.data);
        this.regions = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async submitForm() {
      const formData = new FormData();

      for (const key in this.form) {
        if (this.form.hasOwnProperty(key)) {
          const value = this.form[key];
          if (value !== null && value !== "") {
            formData.append(key, value);
          }
        }
      }

      this.isWaitingRequest = true;

      try {
        await this.$axios({
          method: "POST",
          url: `orders/${this.$route.params.id}/add-adress`,
          data: formData,
        });

        this.isWaitingRequest = false;
        this.$message.success(
          this.$t("MESSAGES.delivaryInformationSuccessfully")
        );
        this.$router.push({ path: "/orders/all" }); // توجيه المستخدم بعد النجاح
      } catch (error) {
        console.log(error);
        this.$message.error(
          error.response?.data?.message || "An error occurred"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },

    validateFormInputs() {
      this.submitForm();
    },
  },

  created() {
    // Start:: Fire Methods
    this.showOrder();
    // End:: Fire Methods
  },
};
</script>
<style>
.comment {
  border: 1px solid #F7941E;
  padding: 15px;
  border-radius: 6px;
}
.comment_label {
  color: #F7941E;
  font-size: 16px;
}
</style>
